export default __webpack_public_path__ + "static/media/setup-csp.9193745e.mts";